import Form from "../../widgets/Form";
import { useLoaderData } from "react-router-dom";
import { getData } from "../../app/utils/api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Company = () => {
  const data: any = useLoaderData();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(data);
  const [errorMessage, setErrorMessage] = useState("");
  const [formError, setFormError] = useState("");

  if (formData.location_href) {
    window.location.href = formData.location_href;
    return;
  }

  const handleSubmit = async ({ url, form }: any) => {
    setFormError("");

    try {
      const req = await getData({
        url,
        method: "POST",
        data: form,
      });

      if (req.redirect_url) {
        navigate(req.redirect_url);
        return;
      }

      setFormData(req);
    } catch (e) {
      setErrorMessage("Неопознанная ошибка. Обратитесь к менеджеру.");
    }
  };

  return formData ? (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {formData && (
              <Form
                data={formData as any}
                onSubmit={handleSubmit}
                onBack={(url) => {}}
                formError={formError}
              />
            )}
            {errorMessage && <h4>{errorMessage}</h4>}
          </div>
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Company;
